module.exports = __webpack_public_path__ + "img/yonghedawang.f6e50863.png";